import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import ProductCard from "@/components/ProductCard";
import { api } from "@/lib/api";

export default function BestSellers() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/products/bestsellers?limit=8").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <section data-testid="best-sellers" className="px-5 sm:px-6 md:px-12 lg:px-16 py-12 md:py-20 bg-background">
      <div className="flex items-center gap-3 mb-8">
        <Flame className="w-6 h-6 text-primary" />
        <div>
          <p className="text-xs uppercase tracking-[0.35em] font-bold text-primary">Trending Now</p>
          <h2 className="font-anton text-3xl sm:text-4xl uppercase tracking-tight text-white leading-none mt-1">
            Fan Favorites
          </h2>
        </div>
      </div>
      <div className="flex gap-3 sm:gap-5 overflow-x-auto pb-4 -mx-1 px-1 no-scrollbar snap-x">
        {items.map((p, i) => (
          <div key={p.id} className="snap-start shrink-0 w-[45%] sm:w-56 md:w-64">
            <ProductCard product={p} index={i} />
          </div>
        ))}
      </div>
    </section>
  );
}
